import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import VueCurrencyInput from "vue-currency-input";
Vue.use(VueCurrencyInput);

Vue.config.productionTip = false;

window.globalItemsPerPageOptions = [6, 15, 50, 100, -1];

axios.defaults.timeout = 180000;
axios.defaults.headers.Authorization = "Bearer " + localStorage.getItem("token");
axios.defaults.baseURL = `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}`;

Vue.prototype.$axios = axios;

Vue.mixin({
  methods: {
    km: (value) => value.toLocaleString().replace(",", "."),
    eur: (amount) => {
      var formatter = new Intl.NumberFormat("sl-SI", {
        style: "currency",
        currency: "EUR",
      });
      return formatter.format(amount);
    },

    datum: (val) => {
      return new Date(val).toLocaleDateString("sl-SI", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
      });
    },
    humanDatum: (val) => {
      if (val === null) {
        return "";
      }

      var dat = new Date(val);
      var today = new Date();
      var yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      if (dat.toDateString() === today.toDateString()) {
        return "<strong>DANES</strong>";
      }
      if (dat.toDateString() === yesterday.toDateString()) {
        return "<strong>Včeraj</strong>";
      }
      return new Date(val).toLocaleDateString("sl-SI", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
      });
    },
  },
});

new Vue({
  data: {
    delavnice: {
      selectItems: [],
    },
  },
  created() {
    this.$axios
      .get(`/delavnice`)
      .then((response) => (this.delavnice.selectItems = eval(response.data)))
      .catch(function(error) {
        // console.log(error.request.status, error.config.url);
      });
  },
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
